export const removeSkippedElements = (clipboardNode: Element) => {
  const elements = Array.from(
    clipboardNode.querySelectorAll("[data-slate-clipboard-skip]")
  );

  elements.forEach((elem) => elem.remove());
};
